import InfoBubble from "./InfoBubble"

export default  InfoBubble;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/InfoBubble/index.js